export default __webpack_public_path__ + "static/media/food4.1d280b4a.png";